
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "itemShared2352141355",
      {"classes":{"root":"itemShared2352141355__root","rootContainer":"itemShared2352141355__rootContainer","menuItem":"itemShared2352141355__menuItem","accessibilityIconWrapper":"itemShared2352141355__accessibilityIconWrapper","accessibilityIcon":"itemShared2352141355__accessibilityIcon"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  